



























/* eslint-disable @typescript-eslint/camelcase */

import {
  getCartePlaceListing,
  getCartePlaceListingVariables,
  getCartePlaceListing_getCartePlaceListing,
  getCartePlaceListing_getCartePlaceListing_edges_node
} from "../graphql/types/getCartePlaceListing";

import AppTextModule from "../store/modules/appTextModule";
import { Component } from "vue-property-decorator";
import ManufactureList from "../components/ManufactureList.vue";
import QueryPlace from "../graphql/queryPlace";
import Util from "../util";
import ViewBase from "../views/ViewBase";
import { getModule } from "vuex-module-decorators";

const appTextStore = getModule(AppTextModule);

@Component({
  apollo: {
    cartePlaceListing: {
      query: QueryPlace.getCartePlaceListing,
      variables(): getCartePlaceListingVariables {
        return {
          language: `${this.language}`
        };
      },
      update(data: getCartePlaceListing) {
        // The returned value will update
        // the vue property 'cartePlaceListing'
        const result = data?.getCartePlaceListing;
        return result;
      },
      fetchPolicy: "cache-and-network",
      error(error) {
        this.onError(error);
      }
    }
  },
  components: { ManufactureList }
})
export default class Places extends ViewBase {
  private cartePlaceListing?: getCartePlaceListing_getCartePlaceListing;

  protected get title() {
    return appTextStore.appTextByKey("text.places");
  }

  private get edges() {
    return Util.removeNull(this.cartePlaceListing?.edges);
  }

  private nodeId(
    node?: getCartePlaceListing_getCartePlaceListing_edges_node | null
  ) {
    return Util.itemId(node);
  }
}
